import { FC, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';

import { Loader } from '@/widgets/Loader';
import { NotFoundPage } from '@/page/NotFoundPage';
import { routeConfig } from '@/shared/route/route';

/** Роутер */
export const Router: FC = () => {
    return (
        <Suspense fallback={<Loader detail="Загружаем страницу" />}>
            <Routes>
                {Object.values(routeConfig).map((route) => {
                    return <Route path={route.path} element={route.element} key={route.path} />;
                })}
                <Route path="*" element={<NotFoundPage />} />
            </Routes>
        </Suspense>
    );
};
